module.exports = __webpack_public_path__ + "img/om.d8fbf0d2.svg";